import { render, staticRenderFns } from "./AtmoInfoPm25.vue?vue&type=template&id=cb1a7504&scoped=true&"
import script from "./AtmoInfoPm25.vue?vue&type=script&lang=ts&"
export * from "./AtmoInfoPm25.vue?vue&type=script&lang=ts&"
import style0 from "./AtmoInfoPm25.vue?vue&type=style&index=0&id=cb1a7504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a7504",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1a7504')) {
      api.createRecord('cb1a7504', component.options)
    } else {
      api.reload('cb1a7504', component.options)
    }
    module.hot.accept("./AtmoInfoPm25.vue?vue&type=template&id=cb1a7504&scoped=true&", function () {
      api.rerender('cb1a7504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoPm25.vue"
export default component.exports